import i18n from '@/i18n/i18n'
import InterestRateService from '@/services/admin/InterestRateService.js'
import { build_query } from '@/utilities/helpers.js'

const { t } = i18n.global

export const allowedFilters = []
export const allowedSorts = '-created_at'
export const allowedIncludes = ''
export const allowedAppends = ''

export const namespaced = true

export const state = {
  interestRates: null,
  interestRate: {},
  meta: null,
  withTrashed: false
}

export const mutations = {
  SET_INTEREST_RATES(state, interestRates) {
    interestRates.data.forEach(item => {
      item.active = Number(!item.deleted_at)
    })
    state.interestRates = interestRates.data
    state.meta = interestRates.meta
  },
  SET_INTEREST_RATE(state, interestRate) {
    state.interestRate = interestRate
  },
  ADD_INTEREST_RATE(state, interestRate) {
    interestRate.active = 1
    state.interestRates.push(interestRate)
  },
  DELETE_INTEREST_RATE(state, id) {
    state.interestRates.find(rate => rate.id === id).active = 0
    state.interestRates.find(rate => rate.id === id).deleted_at = true
  },
  SET_WITH_TRASHED(state, value) {
    state.withTrashed = value
  }
}

export const actions = {
  getInterestRates({ commit, dispatch, state }, query = {}) {
    let newQuery = build_query(query, allowedFilters, allowedIncludes, allowedSorts, allowedAppends)

    if (state.withTrashed) {
      newQuery['filter[trashed]'] = 'with'
    }

    return new Promise((resolve, reject) => {
      InterestRateService.getInterestRates(newQuery)
        .then(response => {
          commit('SET_INTEREST_RATES', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.interest_rate.get_interest_rates_error')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getInterestRate({ commit }, id) {
    return new Promise(resolve => {
      InterestRateService.getInterestRate(id).then(response => {
        commit('SET_INTEREST_RATE', response.data)

        resolve(response.data)
      })
    })
  },
  createInterestRate({ dispatch, commit, state }, interestRate) {
    return new Promise((resolve, reject) => {
      InterestRateService.createInterestRate(interestRate)
        .then(response => {
          if (state.interestRates) {
            commit('ADD_INTEREST_RATE', response.data)
          }
          const notification = {
            type: 'success',
            message: t('store.admin.interest_rate.create_interest_rate_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.interest_rate.create_interest_rate_error')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deleteInterestRate({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      InterestRateService.deleteInterestRate(params.id)
        .then(response => {
          commit('DELETE_INTEREST_RATE', params.id)
          const notification = {
            type: 'success',
            message: t('store.admin.interest_rate.delete_interest_rate_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.interest_rate.delete_interest_rate_error')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
